import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleriaModule } from 'primeng/galleria';
import { BrandedGalleryComponent } from './branded-gallery/branded-gallery.component';
import { ButtonModule } from 'primeng/button';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';

@NgModule({
  imports: [CommonModule, GalleriaModule, SharedUtilsModule, SharedUtilsImageModule, ButtonModule],
  declarations: [BrandedGalleryComponent],
  exports: [BrandedGalleryComponent]
})
export class BrandedPageUiBrandedGalleryModule {}
